<template lang="pug">
  .leaders-table.swiper-container(v-if="leaders")
    .leaders-table__wrapper.swiper-wrapper
      .swiper-slide
        table.table.table_bordered.table_simple(style="table-layout: fixed;")
          colgroup
            col(width="52")
          thead
            tr
              th
              th Дистанция
          tbody
            tr(v-for="i in [0, 1, 2]")
              td
                div(style="width: 40px; min-width: 40px; height: 40px")
                  img(
                    :src="require(`@/assets/img/icons/${i + 1}-place-medal.svg`)"
                    width="100%"
                    alt="1"
                  )
              td
                table.table.table_x-paddings
                  tbody
                    tr(v-if="leaders.byDistance[i]")
                      td
                        Member(
                          :userId="leaders.byDistance[i].id"
                          :name="leaders.byDistance[i].fullName"
                          :img="leaders.byDistance[i].avatarSmallUrl"
                        )
                      td.text-right: span.text-lg {{ leaders.byDistance[i].totalDistance }}&nbsp;<span class="text-xs">км</span>
                    tr(v-else)
                      td(colspan="2").text-center --
      .swiper-slide
        table.table.table_bordered.table_simple(style="table-layout: fixed;")
          colgroup
            col(width="52")
          thead
            tr
              th
              th Длительность
          tbody
            tr(v-for="i in [0, 1, 2]")
              td
                div(style="width: 40px; min-width: 40px; height: 40px")
                  img(
                    :src="require(`@/assets/img/icons/${i + 1}-place-medal.svg`)"
                    width="100%"
                    alt="1"
                  )
              td
                table.table.table_x-paddings
                  tbody
                    tr(v-if="leaders.byTime[i]")
                      td
                        Member(
                          :userId="leaders.byTime[i].id"
                          :name="leaders.byTime[i].fullName"
                          :img="leaders.byTime[i].avatarSmallUrl"
                        )
                      td.text-right: span.text-lg {{ leaders.byTime[i].totalTime }}
                    tr(v-else)
                      td(colspan="2").text-center --
      .swiper-slide
        table.table.table_bordered.table_simple(style="table-layout: fixed;")
          colgroup
            col(width="52")
          thead
            tr
              th
              th Подъём в гору
          tbody
            tr(v-for="i in [0, 1, 2]")
              td
                div(style="width: 40px; min-width: 40px; height: 40px")
                  img(
                    :src="require(`@/assets/img/icons/${i + 1}-place-medal.svg`)"
                    width="100%"
                    alt="1"
                  )
              td
                table.table.table_x-paddings
                  tbody
                    tr(v-if="leaders.byHeight[i]")
                      td
                        Member(
                          :userId="leaders.byHeight[i].id"
                          :name="leaders.byHeight[i].fullName"
                          :img="leaders.byHeight[i].avatarSmallUrl"
                        )
                      td.text-right: span.text-lg {{ leaders.byHeight[i].totalHeight }}&nbsp;<span class="text-xs">м</span>
                    tr(v-else)
                      td(colspan="2").text-center --
    .swiper-pagination
</template>

<script>
import Member from '@/components/Member'
import Swiper, { Pagination } from 'swiper'
Swiper.use([Pagination])

export default {
  name: 'LeadersTableMobile',
  components: {
    Member
  },
  props: {
    leaders: Object
  },
  mounted () {
    this.slider = new Swiper('.leaders-table', {
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }
    })
  }
}
</script>

<style lang="scss">
  .table .member {
    word-break: break-word;
  }

  .leaders-table {
    overflow: hidden;

    &__wrapper {
      display: flex;
      flex-wrap: nowrap;
    }

    .swiper-slide {
      flex: 0 0 auto;
      width: 100%;
    }

    .swiper-pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 12px;
    }

    .swiper-pagination-bullet {
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: map_get($color-neutral-black, 4);
      margin: 0 4px;

      &.swiper-pagination-bullet-active {
        background-color: $color-primary;
      }
    }
  }
</style>
